<template>
    <div>
        <el-dropdown trigger="click" @command="handleClick" style="margin-right: 10px">
            <el-button type="warning" plain>
                <i class="fa fa-upload"></i> Import from
                <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="import_csv">CSV</el-dropdown-item>
                <el-dropdown-item command="import_quote">Quote</el-dropdown-item>
                <el-dropdown-item command="import_proposal">Proposal</el-dropdown-item>
                <el-dropdown-item command="import_job">Job</el-dropdown-item>
                <el-dropdown-item command="import_campaign">Campaign</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>

        <import-csv 
            :open-dialog.sync="show_dialogs.import_csv"
            :area-id="areaId"
            @process="$emit('process')"
        />
        <import-from-quote 
            :open-dialog.sync="show_dialogs.import_quote"
            :area-id="areaId"
            @process="$emit('process')"
        />
        <import-from-proposal 
            :open-dialog.sync="show_dialogs.import_proposal"
            :area-id="areaId"
            @process="$emit('process')"
        />
        <import-from-job 
            :open-dialog.sync="show_dialogs.import_job"
            :area-id="areaId"
            @process="$emit('process')"
        />
        <import-from-campaign 
            :open-dialog.sync="show_dialogs.import_campaign"
            :area-id="areaId"
            @process="$emit('process')"
        />
    </div>
</template>

<script>
import ImportCsv from './dialogs/import-csv.vue';
import ImportFromQuote from './dialogs/import-from-quote.vue';
import ImportFromProposal from './dialogs/import-from-proposal.vue';
import ImportFromJob from './dialogs/import-from-job.vue';
import ImportFromCampaign from './dialogs/import-from-campaign.vue';

export default {
    components: { 
        ImportCsv,
        ImportFromQuote,
        ImportFromProposal,
        ImportFromJob,
        ImportFromCampaign
    },
    props: {
        areaId: { type: Number, required: true },
    },
    data() {
        return {
            show_dialogs: {
                import_csv: false,
                import_quote: false,
                import_proposal: false,
                import_job: false,
                import_campaign: false
            }
        };
    },
    methods: {
        handleClick(test) {
            console.log(test);

            this.show_dialogs[test] = true;
        }
    }
};
</script>

